// Gardeno Premium list prices (US store), for the marketing site and legal
// pages. The app itself always shows the App Store's live, localized price.
//
// The annual plan goes from $29.99 to $39.99 for new subscribers at the start
// of 30 Oct 2026 Pacific time (App Store Connect's schedule). Existing
// subscribers keep the price they signed up at. The switch is by date so the
// site changes on the day without another deploy; the same instant is
// AnnualPriceChangeAt in the backend's internal/revenue/listprice.go.
export const ANNUAL_PRICE_CHANGE = new Date('2026-10-30T07:00:00Z');

export const MONTHLY_PRICE = 3.99;
const ANNUAL_PRICE_BEFORE = 29.99;
const ANNUAL_PRICE_AFTER = 39.99;

export function annualPriceIncreased(now: Date = new Date()): boolean {
  return now.getTime() >= ANNUAL_PRICE_CHANGE.getTime();
}

export function annualPrice(now: Date = new Date()): number {
  return annualPriceIncreased(now) ? ANNUAL_PRICE_AFTER : ANNUAL_PRICE_BEFORE;
}

/** "$39.99" */
export function usd(n: number): string {
  return `$${n.toFixed(2)}`;
}
